import React, { useEffect, useState } from "react";
import Layout from "../components/Layoutthree";
import { BtnPrimary } from "../components/buttons/BtnPrimary";
import { BtnOutline } from "../components/buttons/BtnOutline";
import { ServiceCard } from "../components/ServiceCard";
import soc2 from "../images/soc2.svg";
import jumpcloud from "../images/jumpcloud.svg";
import aicpa from "../images/compliance4.png";
import webApp from "../images/webApp.svg";
import mobileApp from "../images/mobileApp.svg";
import data from "../images/data.svg";
import iot from "../images/iot.svg";
import cloudDevOps from "../images/cloudDevOps.svg";
import uiux from "../images/uiux.svg";
import taraIcon from "../images/healthtransparency-icon.svg";
import providerIcon from "../images/provider-icon-home.svg";
import customerIcon from "../images/customer-icon-home.svg";
import nextStep from "../images/next-step.svg";
import { Form } from "../components/form";
import { Carousel } from "react-responsive-carousel";
import { SEO } from "../components/seo";
import { Helmet } from "react-helmet";
import nemo from "../images/nemo-logo.png";
import benebay from "../images/benebay-logo.png";
import higi from "../images/higi-logo.png";
import claros from "../images/claros-logo.png";
import instride from "../images/InStride_Health_Horiz_Color_RGB.png";
import quote from "../images/quote.png";
import tara from "../images/tara-ss.png";
import provider from "../images/provider.png";
import testimonial1 from "../images/testimonial-photo.jpeg";
import shapeBg from "../images/accent-product.png";
import launch from "../images/launched.png";
import MRF from "../images/MRF.jpeg";

const IndexPage = () => {
  // const [playVideo, setPlayVideo] = useState(false);

  // const handleClose = () => {
  //   setPlayVideo(false);
  // };
  // useEffect(() => {
  //   const hasPlayedVideo = sessionStorage.getItem("hasPlayedVideo");

  //   if (!hasPlayedVideo) {
  //     setPlayVideo(true);
  //     sessionStorage.setItem("hasPlayedVideo", "true");
  //   }
  // }, []);
  // const whatWeDo = [
  //   {
  //     key: "one",
  //     name: "Web App Development",
  //     svg: webApp,
  //     link: "/web-app",
  //     text: "We build powerful and scalable web apps that are custom made using agile development processes leveraging the latest web technologies. ",
  //   },
  //   {
  //     key: "two",
  //     name: "Mobile App Development",
  //     svg: mobileApp,
  //     link: "/mob-app",
  //     text: "IOS and Android applications for mobile devices, as well as applications that can run on iOS and Android when cross compatibility is desired.",
  //   },
  //   {
  //     key: "three",
  //     name: "Data Handling",
  //     svg: data,
  //     link: "/data-handling",
  //     text: "Meaningful and pragmatic insights from data and analytics to support decision making",
  //   },
  //   {
  //     name: "IoT Development",
  //     svg: iot,
  //     link: "/iot",
  //     text: "A complete spectrum of IoT development that incorporates consultation, development and implementation, analytics, support, and evolution",
  //   },
  //   {
  //     key: "five",
  //     name: "Cloud and DevOps",
  //     svg: cloudDevOps,
  //     link: "/devops",
  //     text: "Deliver high-quality software with consistency by automating end to end delivery pipeline across leading cloud platforms",
  //   },
  //   {
  //     key: "six",
  //     name: "UI/UX Design",
  //     svg: uiux,
  //     link: "/ui-ux",
  //     text: "Create first-class designs to help improve user experiences, customer satisfaction, brand perception, and conversion rates.",
  //   },
  // ];

  const [flag, setFlag] = useState(false);

  const whatWeDoServices = [
    {
      name: "Custom Software Development",
      svg: customerIcon,
      link: "/custom-software-development",
      text: "We build powerful and scalable web and mobile apps that are custom-made using agile development processes leveraging the latest technologies.",
    },
    {
      key: "five",
      name: "Cloud and DevOps",
      svg: cloudDevOps,
      link: "/devops",
      text: "Deliver high-quality software with consistency by automating end to end delivery pipeline across leading cloud platforms",
    },
    {
      key: "three",
      name: "Data Handling",
      svg: data,
      link: "/data-handling",
      text: "Meaningful and pragmatic insights from data and analytics to support decision making",
    },
    {
      key: "four",
      name: "UI/UX Design",
      svg: uiux,
      link: "/ui-ux",
      text: "Create first-class designs to help improve user experiences, customer satisfaction, brand perception, and conversion rates",
    },
  ];

  return (
        <Layout>
          <Helmet title="Deerhold: SaaS-Based Solutions and IT Services" />
          <SEO />
      <div>
        {/* {playVideo && (
          <div className="video-overlay">
            <div className="video-container" >
              <video
               className="custom-video-controls"
               controls
                autoPlay
                muted
                playsInline
                loop
                onEnded={handleClose}
                controlslist="nodownload noplaybackrate"
                disablepictureinpicture=""

              >
                <source
                  src="https://dh-website-bucket.s3.us-east-1.amazonaws.com/ChristmasVideo.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <button className="btn-close" onClick={handleClose} aria-label="Close"></button>
              </div>
          </div>
        )} */}
            <div>
              <section className="hero-section">
                <div className="hero-content d-flex flex-column gap-3 container">
                  <div className="d-flex flex-column gap-1">
                    <h2 className="hero-title text-bold text-dark">
                      Deerhold is the leading provider of{" "}
                      <span className="text-primary">
                        Transparency Market Intelligence
                      </span>{" "}
                      solutions in the United States as well as engineering solutions
                      to companies across the globe.
                    </h2>
                    <p className="hero-text">
                      Our customizable SaaS solutions and expert IT services help
                      businesses of all sizes reach their full potential and achieve
                      their goals.
                    </p>
                  </div>
                  <BtnPrimary btnText="Contact Us" link="/contact" />
                </div>
                <div className="hero-image container-fluid"></div>
              </section>
              {/* <div className="ripple-background">
          <div className="circle xxlarge shade1"></div>
          <div className="circle xlarge shade2"></div>
          <div className="circle large shade3"></div>
          <div className="circle mediun shade4"></div>
          <div className="circle small shade5"></div>

        </div> */}
              <div className="shapes-accent container-fluid bg-white">
                <img src={shapeBg} alt="" className="shapes-bg" />
              </div>
              <section className="products">
                <hr className="orange-line" />
                <h1 className=" container section-title text-center text-md-start">
                  Products
                </h1>
                <div className="container-fluid mrf-content d-flex align-items-center">
                  <div className="d-flex flex-column align-items-center align-items-md-start gap-4 container ps-4">
                    <span className="d-flex flex-column flex-md-row gap-4 align-items-center">
                      <img
                        src={launch}
                        alt="MRF launch icon"
                        className="launch-icon"
                      />
                      <h2 className="mrf-launch text-uppercase fw-bold text-white">
                        CONTRACT RATE EXPLORER
                      </h2>
                    </span>
                    <p className="mb-3">
                      Inform business decisions by unlocking the power of payer MRFs
                      for <br /> actionable insights that are relevant for your
                      specific needs.
                    </p>
                    <BtnPrimary btnText="More Info" link="/contract-rate-explorer" />
                  </div>
                </div>
                <div className="container ps-4 pe-3 ">
                  <div className="tara row py-md-4 py-2">
                    <div className="col-12 col-md-5">
                      <div className="d-flex tara-text flex-column gap-2">
                        <h1 className="product-title">
                          <a
                            href="/healthcare-price-transparency"
                            className=" text-decoration-none"
                          >
                            TARA
                          </a>
                        </h1>
                        <h4 className="product-sub-title">
                          (Healthcare Price Transparency)
                        </h4>
                        <p>
                          Get compliant and stay compliant with Tara, an online tool
                          that allows members to estimate cost sharing for covered
                          healthcare items and services.
                        </p>
                        <button
                          type="button"
                          class="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        >
                          Request a Demo
                        </button>
                      </div>
                    </div>
                    <div
                      class="modal fade"
                      id="exampleModal"
                      tabIndex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header m-3">
                            <h3 class="text-bold" id="exampleModalLabel">
                              Request a demo
                            </h3>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <Form
                              name={true}
                              product={true}
                              email={true}
                              contact={true}
                              message={true}
                              messageRequired={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7 col-12  mt-3">
                      {/* <div className="product-image"></div> */}
                      <img src={tara} alt=".." className="product-image" />
                    </div>
                  </div>
                  <div className="tara row py-md-4 py-2">
                    {/* <div className="col-12 col-md-5">
                <div className="d-flex tara-text flex-column gap-2">
                  <h1 className="product-title">
                    <a
                      href="/provider-search"
                      className=" text-decoration-none"
                    >
                      Provider Search
                    </a>{" "}
                  </h1>

                  <p>
                    Give members an online provider search tool that lets them
                    look for providers by name, specialty, facility, network, or
                    location.
                  </p>
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    Request a Demo
                  </button>
                </div>
              </div> */}
                  </div>
                </div>
              </section>
            </div>
            <section className="what-we-do py-5">
              <hr className="orange-line"></hr>
              <div className="container">
                <div className="whatwedo-text">
                  <h1 className="section-title text-center text-md-start">
                    Services
                  </h1>
                  <p>
                    Deerhold is a healthcare product, services and analytics company
                    based in Lexington, Massachusetts, USA with a major offshore
                    office in Nepal and development center in Tokyo, Japan. Our strong
                    network of hundreds of software engineers spans these three
                    locations. This talented pool of resources collectively provides
                    you with an unparalleled range of solutions and services around
                    the clock.
                    <br />
                    <br />
                    Our premier and heavily used service by our customers is
                    healthcare data handling services. We provide a cloud based
                    solution to you when it comes to managing your data pipes. We
                    acquire, clean, QC and transfer data to your desired destination.
                  </p>
                  <div className="mt-4">
                    <BtnPrimary btnText="Learn more" link="/our-services" />
                  </div>
                </div>

                <div className="section-cards row gx-2">
                  {whatWeDoServices.map((i) => {
                    return <ServiceCard content={i} key={i} />;
                  })}
                </div>
                <br />
              </div>
            </section>

            <section className="next-step">
              <div className="container d-flex justify-content-between align-items-center">
                <div>
                  <h1 className="display-4">Ready to take the next step?</h1>
                  <h4 className="mt-4 mb-5">Contact us for Solution inquiries</h4>
                  <BtnPrimary btnText="Contact Now" link="/contact" />
                </div>
                <div className="d-none d-md-block">
                  <img src={nextStep} alt="Next Step" loading="lazy" />
                </div>
              </div>
            </section>
            {/* 
      <section className="testimonial container">
        <div className="testimonial-heading">
          <h5>What our clients say about us.</h5>
          <hr></hr>
        </div>

        <div
          id="carouselExampleDark"
          class="carousel carousel-dark slide testimonial-slide"
          data-bs-ride="carousel"
        >
          <div class="carousel-inner">
            <div class="carousel-item active" data-bs-interval="8000">
              <div class="testimonial-content">
                <p>
                  "Accuracy and speed are the words I associate with Deerhold.
                  They provide unparalleled service in software development and
                  have earned their place as a trusted partner."
                </p>
                <div className="testimononal-picture">
                  <img  src={testimonial1} className="testimonial-img"/>

                  <h5>David Shein, MD</h5>
                </div>

                <img src={quote} alt="" className="quote-image" />
              </div>
            </div>
            <div class="carousel-item" data-bs-interval="8000">
              <div class="testimonial-content">
                <p>
                  "We work very closely with Deerhold project managers….and they
                  tightly manage software developers…so that we see great
                  progress on great software…every morning"
                </p>
                <div className="testimononal-picture">
                  <img  src={testimonial1} className="testimonial-img"/>

                  <h5>Chris Kryder, MD (NEMO)</h5>
                </div>

                <img src={quote} alt="" className="quote-image" />
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-content">
                
                <p>
                  Some representative placeholder content for the third slide.
                </p>

                <h5>Third slide label</h5>

              </div>
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only"></span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only"></span>
          </button>
        </div>
      </section> */}

            <section className="compliance bg-white">
              <div className="container">
                <div>
                  <a
                    href="https://drata.com/"
                    target={" "}
                    rel="noreferrer noopener"
                    className=" me-0 me-md-5"
                  >
                    {" "}
                    <img
                      src={soc2}
                      className="img-fluid soc"
                      alt="SOC2"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://jumpcloud.com/"
                    target={" "}
                    rel="noreferrer noopener"
                    className=" me-0 me-md-5"
                  >
                    <img
                      src={jumpcloud}
                      className="img-fluid jumpcloud"
                      alt="Jumpcloud"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://www.siia.org/"
                    target={" "}
                    rel="noreferrer noopener"
                    className=" me-0 me-md-5"
                  >
                    <img
                      src="//dh-website-bucket.s3.amazonaws.com/1674625450716"
                      className="img-fluid siia"
                      alt="SIIA"
                    />
                  </a>

                  <a
                    href="https://us.aicpa.org/"
                    target={" "}
                    rel="noreferrer noopener"
                    className=" me-0 me-md-5"
                  >
                    <img
                      src={aicpa}
                      className="img-fluid aicpa"
                      alt="aicpa"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </section>

            {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition="Bounce"
      /> */}
          </div>

        </Layout>

      
    

  );
};

export default IndexPage;

export const Head = () => (
  <SEO
    keywords="Software Company Nepal, Healthcare Software Company, Nepal Offshore, Japan Offshore, Healthcare Solutions, Software Development Nepal, Health Plan Contracting, Engineering Offshore, SaaS Solutions"
    title="Deerhold: SaaS-Based Solutions and IT Services"
    description="A Digital Technology Company SaaS-Based Solutions and IT Services"
    image="/DeerholdOG.jpg"
    pathname="/"
  />
);
